// Searchbox.js
import { useEffect, useRef, useState } from 'react';
import '../App.css';
import { Tabs, Tab, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import KiinteistoHaku from '../classes/Kiinteistohaku';
import { ktKokomuotoon } from '../assets/ktMuuntaja';
import { searchKiinteistot } from '../api/api';

function Search({ afterSearch }) {
  const [kiinteistotunnus, setKiinteistotunnus] = useState("");
  const [osoite, setOsoite] = useState("");
  const [paikkakunta, setPaikkakunta] = useState("");
  const [searchType, setSearchType] = useState('kiinteistötunnuksella'); 
  const [kiinteistoCount, setKiinteistoCount] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterByAddress, setFilterByAddress] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const KH = useRef(new KiinteistoHaku()).current;
  const autoSearched = useRef(false);
const [hasSearched, setHasSearched] = useState(false)

const handleSearch = async (overrides = {}) => {
  const trimmedKt =
    (overrides.kiinteistotunnus ?? kiinteistotunnus).trim();

  const trimmedOsoite =
    (overrides.osoite ?? osoite).trim();

  const trimmedKunta =
    (overrides.paikkakunta ?? paikkakunta).trim();

  const addressFilter =
    overrides.filterByAddress ?? filterByAddress;

    if (!trimmedKt && !trimmedOsoite && trimmedKunta) {
      setError("Haku vaatii kiinteistötunnuksen tai osoitteen.");
      setKiinteistoCount(0);
      afterSearch([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const ktKokomuoto = ktKokomuotoon(trimmedKt);
      const response = await searchKiinteistot(
  ktKokomuoto,
  trimmedOsoite,
  trimmedKunta,
  addressFilter
);
      const data = response.data;

      if (data?.error) {
        setError(data.error);
        setKiinteistoCount(0);
        afterSearch([]);
      } else {
        setError(null);
        setResponseCount(data);
        afterSearch(data);
        setHasSearched(true);
      }
    } catch (err) {
      if (err.response) {
        switch (err.response.status) {
          case 403: setError("Käyttäjä ei ole kirjautunut sisään tai oikeudet puuttuvat (403)"); break;
          case 401: setError("Autentikointi epäonnistui (401)"); break;
          case 500: setError(err.response.data?.error || "Palvelinvirhe (500)"); break;
          default: setError(err.response.data?.error || `Virhe haussa: ${err.response.status}`);
        }
      } else {
        setError("Verkkovirhe tai palvelin ei vastaa");
      }
      setKiinteistoCount(0);
      afterSearch([]);
      console.error("Virhe haussa:", err);
    } finally {
      setLoading(false);
    }
  };
const handleFilterChange = async (e) => {
  const checked = e.target.checked;

  setFilterByAddress(checked);

  if (hasSearched && (osoite.trim() || kiinteistotunnus.trim())) {
    await handleSearch({
      filterByAddress: checked
    });
  }
};
  const setResponseCount = (response) => {
    setKiinteistoCount(response[0]?.rakennukset?.length > 0 ? response.length : 0);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryKiinteistotunnus = queryParams.get('kiinteistotunnus') ?? '';
    const queryOsoite = queryParams.get('osoite') ?? '';
    const queryPaikkakunta = queryParams.get('paikkakunta') ?? '';
    const instant = queryParams.get('instantsearch') === 'true';

    if (queryKiinteistotunnus) setKiinteistotunnus(queryKiinteistotunnus);
    if (queryOsoite) setOsoite(queryOsoite);
    if (queryPaikkakunta) setPaikkakunta(queryPaikkakunta);

    if (instant && !autoSearched.current && (queryOsoite || queryKiinteistotunnus)) {
      autoSearched.current = true;
      handleSearch({ kiinteistotunnus: queryKiinteistotunnus, osoite: queryOsoite, paikkakunta: queryPaikkakunta });
    }
  }, [location.search]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  useEffect(() => {
    navigate(`?kiinteistotunnus=${kiinteistotunnus}&osoite=${osoite}&paikkakunta=${paikkakunta}`);
  }, [kiinteistotunnus, osoite, paikkakunta, navigate]);

  const handleTabChange = (newSearchType) => setSearchType(newSearchType);

  return (
    <div className='search-container'>
      <div className="d-flex flex-column">
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Kiinteistötunnus (esitys- tai täysmuodossa)"
            value={kiinteistotunnus}
            onChange={(e) => setKiinteistotunnus(e.target.value)}
            onKeyDown={handleKeyDown}
            aria-label="Search"
            aria-describedby="button-addon2"
          />
        </div>

        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Osoite"
            value={osoite}
            onChange={(e) => setOsoite(e.target.value)}
            onKeyDown={handleKeyDown}
            aria-label="Search"
            aria-describedby="button-addon2"
          />
        </div>

        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Paikkakunta"
            value={paikkakunta}
            onChange={(e) => setPaikkakunta(e.target.value)}
            onKeyDown={handleKeyDown}
            aria-label="Search"
            aria-describedby="button-addon2"
          />
        </div>
<label
  className="d-flex align-items-center gap-2 px-2 py-1 mb-2 rounded border border-secondary-subtle bg-light"
  style={{
    cursor: 'pointer',
    width: 'fit-content',
    margin: 0
  }}
>
  <div className="form-check form-switch m-0">
    <input
      className="form-check-input"
      type="checkbox"
      role="switch"
      id="filterByAddress"
      checked={filterByAddress}
      onChange={handleFilterChange}
      style={{
        cursor: 'pointer',
        width: '2rem',
        height: '1rem'
      }}
    />
  </div>

  <span
    style={{
      fontSize: '0.8rem',
      whiteSpace: 'nowrap'
    }}
  >
    Rajaa haetun osoitteen rakennuksiin
  </span>
</label>

        <Button variant='success' onClick={handleSearch}>Hae</Button>
      </div>

      {error && (
        <div className="alert alert-danger mt-3" role="alert">{error}</div>
      )}

      <div className='featureAmount-container d-flex align-items-center mt-2'>
        {kiinteistoCount > 0 ? (
          <span className="badge rounded-pill bg-warning text-dark fw-bold px-2 py-2 my-2">
            Kiinteistöjä: {kiinteistoCount}
          </span>
        ) : (
          !error && <span className="badge bg-secondary my-2">Ei tuloksia</span>
        )}
        {loading && <div className="spinner-border ms-3" role="status"></div>}
      </div>
    </div>
  );
}

export default Search;
